export default __webpack_public_path__ + "static/media/mooncropedimg.61a91788.png";